module.exports = "/subscriptions/assets/60c4293a8e1e84cfc81bce4624019b60.png";